import firebase from 'firebase/app'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyCvinEuAufK5X6nRSOO2Nxa2sBALmwb2Wk",
  authDomain: "eddrop-582d8.firebaseapp.com",
  projectId: "eddrop-582d8",
  storageBucket: "eddrop-582d8.appspot.com",
  messagingSenderId: "267292084901",
  appId: "1:267292084901:web:6901a7fad6472652d29b4c",
  measurementId: "G-BJC2HPDQTB"
  };

  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);


  const storage = firebase.storage()


export  {
    storage, firebase as default
  }